<div class="stepper-container">
    <div *ngFor="let step of steps; let i = index;" class="step" [class.active]="i < currentStep">
        <div class="step-icon">
            <img [src]="step.icon" alt="{{ step.title | transloco }}" />
        </div>
        <div *ngIf="i < steps.length" class="step-line" [class.completed]="i < currentStep"></div>
        <br>
        <div *ngIf="!step.toRating; else rating" class="step-content">
            <h4>{{ step.title | transloco }}</h4>
            <h5>{{ (step.date | date:'dd \'de\' MMMM \'de\' yyyy \'ás\' HH\':\'mm') || step.date }}</h5>
            <h3 *ngIf="step.extra">({{ step.extra | currency: "BRL":'symbol' }})</h3>
        </div>
        <ng-template #rating>
            <div class="step-content">
                <h4>{{ step.title | transloco }}</h4>
                <h5>{{ (step.date | date:'dd \'de\' MMMM \'de\' yyyy \'ás\' HH\':\'mm') || step.date }}</h5>
                <h3 *ngIf="step.rating">({{ step.rating }})</h3>
                <button *ngIf="!step.rating" type="button" class="btn btn-link"
                    (click)="openReviewModal($event)">Avaliar
                    Vendedor</button>
            </div>
        </ng-template>
    </div>
    <div class="progress-bar" [style.width.%]="progressWidth"></div>
</div>
